import Vue from 'vue'

let hideControlsTimer = null

function scheduleHideControls(context) {
  unscheduleHideControls();
  hideControlsTimer = setTimeout(() => {
    if (context.state.controlsVisible) {
      context.commit("setVisible", false);
    }
  }, 2000);
}

function unscheduleHideControls() {
  if (hideControlsTimer) {
    clearTimeout(hideControlsTimer);
    hideControlsTimer = null;
  }
}

export default {
  namespaced: true,
  state: {
    controlsVisible: false,
    disableHideCount: 0,
  },
  mutations: {
    setVisible(state, flag) {
      state.controlsVisible = flag;
    },
    disableHide(state) {
      state.disableHideCount++;
    },
    enableHide(state) {
      if (state.disableHideCount > 0) {
        state.disableHideCount--;
      }
    }
  },
  getters: {
  },
  actions: {
    mouseMoved(context) {
      if (context.state.disableHideCount == 0) {
        scheduleHideControls(context);
      }
      if (!context.state.controlsVisible) {
        context.commit('setVisible', true);
      }
    },
    disableHide(context) {
      context.commit('disableHide');
      if (context.state.disableHideCount == 1) {
        unscheduleHideControls();
      }
    },
    enableHide(context) {
      context.commit('enableHide');
      if (context.state.disableHideCount == 0) {
        scheduleHideControls(context);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/controls.js